const TYPES = {
  BUTTON: 1,
  TREATMENT: 2,
  TIME_SLOT: 3,
};

export default TYPES;
